module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAADAQMAAABPvXYpAAAAA1BMVEVOBf+NC4bYAAAAC0lEQVQI12NgQAAAAAwAAeQ06mYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/center_mark_ic_little.png
// module id = X1MW
// module chunks = 1